import { Button, Row, Space, Spin, Tag } from "antd";
import React from "react";
import { LogEvents, LoggerContext } from "../../../../context/logging";

export const DocumentUpload = ({
  onDocumentAdd,
  onDocumentRemove,
  documents,
  loading,
}) => {
  const logger = React.useContext(LoggerContext);

  const fileInputRef = React.useRef(null);

  console.log("i-log> documents", documents);

  return (
    <section>
      <input
        type="file"
        id="file"
        multiple
        onChange={(e) => {
          console.log(e.target);
          console.log(e.target.files);
          onDocumentAdd(e.target.files);
        }}
        ref={fileInputRef}
        style={{ width: 1, height: 1, opacity: 0, overflow: "hidden" }}
      />
      <Space>
        <Button
          onClick={() => {
            logger.log(LogEvents.uploadPoDocument, {});
            fileInputRef.current?.click();
          }}
        >
          Add Documents
        </Button>
        {loading && <Spin />}
      </Space>
      <Row className="p-2">
        {documents.map((file) => (
          <Tag
            closable
            onClose={(e) => {
              e.preventDefault();
              onDocumentRemove(file);
            }}
            className="mb-2"
          >
            {file?.file_name ??
              file.document?.replace(
                "https://mysite-powo-pdfs.s3.ap-south-1.amazonaws.com/media/porject_files/",
                ""
              )}
          </Tag>
        ))}
      </Row>
    </section>
  );
};
